// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTATemplate_cta__cuxOb","content":"CTATemplate_content__3OlUS","buttons":"CTATemplate_buttons__1hlFt"};